import { IGif } from "services/types";

interface IMixWithBoostedProps {
  // The contents that we inject into.
  gifs: IGif[];

  // Gifs to be injected.
  boostedPostData: IGif[];

  // True if we're in tiles mode, showing no boosted gifs.
  tiles: boolean;
}

export const mixWithBoosted = ({ gifs, boostedPostData, tiles }: IMixWithBoostedProps): IGif[] => {
  if (tiles) {
    return gifs.filter(
      gif => !boostedPostData.map((post: IGif) => post.id).includes(gif.id)
    );
  }

  // IDs of boosted gifs.
  const boostedGifIds = new Set(boostedPostData.map(gif => gif.id));

  // Filter out non-boosted gifs that have a corresponding boosted version in the feed.
  const uniqueGifs = gifs.filter(gif => !boostedGifIds.has(gif.id));

  const newArr: IGif[] = [];

  for (let i = 0; i < uniqueGifs.length; i++) {
    newArr.push(uniqueGifs[i]);

    if ((i + 1) % 3 === 0) {
      const boostedGif = boostedPostData.shift();

      if (boostedGif) {
        newArr.push(boostedGif);
      }
    }
  }

  return newArr;
};
